<template>

    <div class="account-login booking-container">

        <div class="row justify-content-center w-100">


            <div class="col-xl-12 ">
                <div class=" has-shadow  bg-white mb-5 w-100">

                    <div class=" pt-8 pb-4 px-7 py-xl-8">

                        <div class="mb-3" v-if="showOTP && !error">
                            <info-box v-bind:type="'success'">
                                <template v-slot:body>
                                    <span class="heading">
                                        Success

                                    </span>

                                    <div>
                                        <p>
                                            If an account has been found for that email address, we will send an email.

                                        </p>
                                    </div>
                                </template>
                            </info-box>
                        </div>

                        <div v-if="error" class="mb-3">

                            <info-box v-bind:type="'error'">
                                <template v-slot:body>
                                    <span class="heading">
                                        Error

                                    </span>

                                    <div v-if="errorText.length">
                                        <p>
                                            {{errorText}}
                                        </p>
                                    </div>
                                </template>
                            </info-box>
                        </div>


                        <div class="row">
                            <div class="col-24 ">



                                <h2>Password Reset</h2>

                                <div v-if="isLoading" style="max-height: 66px; margin-left: 10px;">
                                    <loader></loader>
                                </div>

                                <div v-else>

                                    <div v-if="showOTP">



                                        <Form @submit="onSubmitOTP" :validation-schema="schemaOTP">



                                            <div class="form-group row mb-4">
                                                <p>Please enter the 6-digit code that we sent to your email address below.</p>
                                                <div class="form-group row mb-4">
                                                    <div class="col-24 ">
                                                        <div class="details-label">
                                                            6 digit code
                                                        </div>
                                                        <Field name="code" class="form-control"></Field>
                                                        <ErrorMessage name="code" class="error-message" />
                                                    </div>

                                                </div>

                                            </div>
                                            <div class="form-group mt-5">
                                                <div class="btn-container btn-container--start">

                                                    <div class="d-flex flex-row">
                                                        <button v-bind:disabled="isLoading" class="btn btn--gold" type="submit">Continue</button>

                                                    </div>

                                                </div>
                                            </div>

                                        </Form>
                                    </div>
                                    <div v-else-if="showPasswordEntry">
                                        <Form @submit="onSubmitPassword" :validation-schema="schemaPassword">
                                            <div class="form-group row mb-4">
                                                <p>Please reset your password below.</p>
                                                <div class="form-group row mb-4">
                                                    <div class="col-24 ">
                                                        <div class="details-label">
                                                            Password
                                                        </div>
                                                        <Field name="password" type="password" class="form-control"></Field>
                                                        <ErrorMessage name="password" class="error-message" />
                                                    </div>

                                                </div>

                                            </div>
                                            <div class="form-group row mb-4">

                                                <div class="form-group row mb-4">
                                                    <div class="col-24 ">
                                                        <div class="details-label">
                                                            Confirm password
                                                        </div>
                                                        <Field name="password2" type="password" class="form-control"></Field>
                                                        <ErrorMessage name="password2" class="error-message" />
                                                    </div>

                                                </div>

                                            </div>
                                            <div class="form-group mt-5">
                                                <div class="btn-container btn-container--start">

                                                    <div class="d-flex flex-row">
                                                        <button v-bind:disabled="isLoading" class="btn btn--gold" type="submit">Continue</button>

                                                    </div>

                                                </div>
                                            </div>

                                        </Form>
                                    </div>
                                    <div v-else>
                                        <Form @submit="onSubmit" :validation-schema="schema">
                                            <div class="form-group row mb-4">
                                                <p>In order for us to send a reminder to the correct user, please enter your email address below.</p>
                                                <div class="form-group row mb-4">
                                                    <div class="col-24 ">
                                                        <div class="details-label">
                                                            Email
                                                        </div>
                                                        <Field name="emailAddress" class="form-control"></Field>
                                                        <ErrorMessage name="emailAddress" class="error-message" />
                                                    </div>

                                                </div>

                                            </div>
                                            <div class="form-group mt-5">
                                                <div class="btn-container btn-container--start">

                                                    <div class="d-flex flex-row">
                                                        <button v-bind:disabled="isLoading" class="btn btn--gold" type="submit">Continue</button>

                                                    </div>

                                                </div>
                                            </div>

                                        </Form>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>


            </div>


        </div>
    </div>







</template>

<script>
    import { Field, Form, ErrorMessage } from "vee-validate";
    import * as yup from "yup";
    import { accountStore } from '../store/index';
    import Loader from '@/shared/components/Loader.vue';
    import InfoBox from '@/shared/components/InfoBox.vue';


    import accountapi from '@/shared/api/account';

    export default {
        name: 'AccountPasswordReset',
        mounted() {
            if (this.accountConfiguration == null) {
                accountStore.dispatch("getConfiguration");
            }
        },
        components: {
            Field,
            Form,
            ErrorMessage,
            Loader,
            InfoBox
        },
        computed: {
            configuration() {
                return accountStore.getters.accountConfiguration;
            },
            titles() {
                if (this.configuration != null) {
                    return this.configuration.Titles;
                }
                return [];
            }
        },
        data() {
            const schema = yup.object().shape({
                emailAddress: yup.string().required().email().label("Email address"),
            });

            const schemaOTP = yup.object().shape({
                code: yup.string().required()
                    .min(6, 'Must be exactly 6 digits')
                    .max(6, 'Must be exactly 6 digits')
                    .label("6 digit code"),
            });


            const schemaPassword = yup.object().shape({
                password: yup.string().required().label("Password"),
                password2: yup.string().required().test('passwords-match', 'Passwords must match', function (value) {
                    return this.parent.password === value;
                })
            });

            return {
                showOTP: false,
                showPasswordEntry: false,
                error: false,
                errorText: '',
                isLoading: false,
                schema,
                schemaOTP,
                schemaPassword,
                resetId: null,
                validationId: null,
            }
        },
        methods: {
            onSubmit(values) {

                this.isLoading = true;

                let payload = {
                    emailAddress: values.emailAddress
                };

                accountapi.passwordResetInitiate(
                    payload,
                    s => {

                        this.resetId = s.resetId;
                        this.resetId = s.resetId;
                        this.showOTP = true;
                        this.isLoading = false;
                    },
                    f => {
                        this.isLoading = false;
                    });




            },
            onSubmitOTP(values) {

                this.isLoading = true;

                let payload = {
                    id: this.resetId,
                    otp: values.code
                };

                accountapi.passwordResetConfirm(
                    payload,
                    s => {
                        this.error = false;
                        this.errorText = '';

                        this.validationId = s.validationId;
                        this.showPasswordEntry = true;
                        this.showOTP = false;
                        this.isLoading = false;
                    },
                    f => {
                        this.error = true;
                        this.errorText = f.Message ;
                        this.isLoading = false;
                    });



            },
            onSubmitPassword(values) {

                let o = this;
                this.isLoading = true;

                let payload = {
                    id: this.resetId,
                    validationId: this.validationId,
                    password: values.password,
                    password2: values.password2
                };

                accountapi.passwordResetChange(
                    payload,
                    s => {
                        
                        o.isLoading = false;
                        o.$router.push({ name: 'account_login', query: { reset: true} });
                    },
                    f => {
                        o.isLoading = false;
                    });



            }
        }

    }
</script>

<style scoped>
    .account-login {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: auto !important;
        margin-top: 5%;
        margin-bottom: 5%;
    }

    .account-register-promotion {
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: white;
    }

        .account-register-promotion * {
            color: white !important;
        }

        .account-register-promotion .sub-heading,
        .account-register-promotion p {
            text-transform: uppercase;
            letter-spacing: 4px;
            font-family: 'Playfair Display';
            font-size: 14px;
        }

        .account-register-promotion p {
            margin-bottom: 40px;
        }

        .account-register-promotion h3 {
            position: relative;
            margin-bottom: 140px;
            font-size: 36px;
            font-family: 'Playfair Display';
        }

            .account-register-promotion h3:after {
                content: '';
                display: block;
                background-color: #a18f5b;
                width: 1px;
                height: 60px;
                bottom: -100px;
                left: 50%;
                position: absolute;
            }

        .account-register-promotion h4 {
            font-size: 24px;
            margin-top: 20px;
            margin-bottom: 20px;
            font-family: 'Playfair Display';
        }


        .account-register-promotion ul {
            padding-left: 0;
            list-style-position: inside;
        }

            .account-register-promotion ul li {
                font-family: Montserrat;
                font-size: 14px;
                margin-bottom: 20px;
                position: relative;
                left: -20px;
            }

    .btn-golf {
        border-color: #425260;
    }

    @media(max-width: 1999px) {
        .account-login {
            display: block !important;
        }
    }
</style>
